import { forwardRef, useEffect, useState } from "react";
import { Button, OverlayTrigger, Popover } from "react-bootstrap";

const PanelPopover = forwardRef(
  ({ popper, children, show: _, ...props }, ref) => {
    useEffect(() => {
      popper.scheduleUpdate();
    }, [popper]);

    return (
      <Popover ref={ref} body {...props}>
        {children}
      </Popover>
    )
  }
)

const PanelBasicActions = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (show) {
      const handleDocumentClick = (e) => {
        if (!e.target.classList.contains("more-options")) {
          setShow(false);
        }
      };

      window.addEventListener("click", handleDocumentClick);

      return () => {
        window.removeEventListener("click", handleDocumentClick);
      };
    }
  }, [show]);

  return (
    <OverlayTrigger
      placement="auto-end"
      show
      overlay={
        <PanelPopover style={{ display: !show ? "none" : "initial" }}>
          <div className="panel__basic-actions" />
        </PanelPopover>
      }
    >
      <Button
        title="More Options"
        className="more-options p-1"
        variant="light"
        style={{ border: "1px solid rgba(0, 0, 0, 0.2)" }}
        onClick={() => setShow((prev) => !prev)}
      >
        <span className="more-options fa-solid fa-circle-info" />
      </Button>
    </OverlayTrigger>
  );
};

export default PanelBasicActions;
